import React, { useEffect } from 'react';
import { useTabContext } from '../context/TabContext';
import styles from '../Tabs.module.scss';
// @ts-ignore
import classNames from 'classnames';

type PropsType = {
  id?: string;
  index: string;
  label: string;
  component: React.ReactNode;
  className?: string;
  classNameActive?: string;
  dataCy?: string;
  disableTabIndex?: boolean;
};

const Tab = (props: PropsType) => {
  const { initIndex, currentIndex, onSelectTab } = useTabContext();

  const handleClick = () => {
    if (onSelectTab) {
      onSelectTab(props.index, props.component);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };

  useEffect(() => {
    if (initIndex === props.index) {
      if (onSelectTab) {
        onSelectTab(props.index, props.component);
      }
    }
    // eslint-disable-next-line
  }, [initIndex]);

  return (
    <div
      id={props.id}
      className={classNames(
        styles.tab,
        props.className,
        props.index === currentIndex && props.classNameActive,
        props.index === currentIndex && styles.activeTab
      )}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      data-cy={props.dataCy}
      tabIndex={props.disableTabIndex ? -1 : 0}
    >
      {props.label}
    </div>
  );
};

export default Tab;
